import React from "react";
import PropTypes from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import Button from "@mui/material/Button";

// Limitless Imports
import { withi18n } from "../../../../../customer/components";
const ExtraInfoDetailView = ({
  classes,
  t,
  selected,
  updateInfoCriteria,
  onValueCopied,
  copiedKey
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.extraInfoDetailContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.heading
  }, /*#__PURE__*/React.createElement(IconButton, {
    id: "backToTableView",
    "aria-label": "KeyboardArrowRight",
    onClick: updateInfoCriteria,
    size: "large"
  }, /*#__PURE__*/React.createElement(KeyboardArrowLeft, null)), /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, selected.attribute)), /*#__PURE__*/React.createElement(Typography, {
    className: classes.valueTitle
  }, selected.value), /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: selected.value,
    onCopy: () => {
      onValueCopied({
        copiedKey: "copied"
      });
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: `${classes.copyAnswerButton} ${copiedKey === "copied" ? classes.copyAnswerButtonSuccess : ""}`,
    color: "secondary",
    variant: "contained",
    id: "copyAnswerButton"
  }, copiedKey === "copied" ? t("Copied") : t("Copy Value"))));
};
const styles = theme => ({
  extraInfoDetailContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1
  },
  heading: {
    display: "flex",
    alignItems: "center"
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 500
  },
  valueTitle: {
    marginLeft: 48
  },
  copyAnswerButton: {
    width: 140,
    margin: "40px auto 0"
  },
  copyAnswerButtonSuccess: {
    backgroundColor: "#4caf50",
    "&:hover": {
      backgroundColor: "#4caf50"
    }
  }
});
export default withStyles(styles)(withi18n(ExtraInfoDetailView, "ExtraInfoDetailView"));
ExtraInfoDetailView.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  selected: PropTypes.object.isRequired,
  onValueCopied: PropTypes.func.isRequired,
  updateInfoCriteria: PropTypes.func.isRequired,
  copiedKey: PropTypes.string.isRequired
};